export default __webpack_public_path__ + "static/latitude-financial-comparison-table-69b68778e0ce355e1d391a4bb722f074.png";